import { Rocket, Sprout, Zap } from 'lucide-react';
import { memo } from 'react';

import type { DifficultyLevel } from '../constants';

import { DIFFICULTY_COLORS } from '../constants';

interface DifficultyBadgeProps {
  difficulty: DifficultyLevel;
}

const DifficultyBadge = memo(({ difficulty }: DifficultyBadgeProps) => {
  const getDifficultyConfig = (difficulty: DifficultyLevel) => {
    switch (difficulty) {
      case 'Beginner':
        return {
          className: DIFFICULTY_COLORS[difficulty],
          icon: Sprout,
        };
      case 'Intermediate':
        return {
          className: DIFFICULTY_COLORS[difficulty],
          icon: Zap,
        };
      case 'Advanced':
        return {
          className: DIFFICULTY_COLORS[difficulty],
          icon: Rocket,
        };
      default:
        return {
          className: 'feedback-success',
          icon: Sprout,
        };
    }
  };

  const difficultyConfig = getDifficultyConfig(difficulty);
  const IconComponent = difficultyConfig.icon;

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-semibold
${difficultyConfig.className} transition-all duration-200`}
    >
      <IconComponent aria-hidden="true" className="w-3.5 h-3.5" />
      <span>{difficulty}</span>
    </div>
  );
});

DifficultyBadge.displayName = 'DifficultyBadge';

export default DifficultyBadge;
